import { useDispatch, useSelector } from "react-redux";
import { type RootState } from "~/redux/store";
import { selectProductDescriptor } from "~/redux/products/productsSelectors";
import { useTranslation } from "react-i18next";
import { useMemo } from "react";
import { isPackageRestrictionEnabled } from "~/common/components/PackageRestrictionContext/utils/isPackageRestrictionEnabled";
import { selectPackageBasedOnQuery } from "~/utils/cartHelper";
import { addMessage } from "~/redux/globalMessages/actions";

export const useCalculateRestrictedCode = (query: string, productCode: string) => {
  const productDescriptor = useSelector((state: RootState) =>
    selectProductDescriptor(state, { productCode, priceReference: "" })
  );

  const { t } = useTranslation();
  const dispatch = useDispatch();

  const restrictedCode = useMemo(() => {
    if (!isPackageRestrictionEnabled()) {
      return null;
    }

    if (!productDescriptor.availability) {
      return null;
    }
    const restrictedPackage = selectPackageBasedOnQuery(query)(productDescriptor.availability, productDescriptor.base);
    if (!restrictedPackage) {
      if (query.replace(/-/g, "").length === 15) {
        dispatch(addMessage("info", t("restrictedPackaging.notFound")));
      }
      return null;
    }
    return restrictedPackage.packCode;
  }, [productDescriptor.availability, productDescriptor.base, query]);

  return restrictedCode;
};
